
import { useDispatch } from "react-redux";
import API from "../api";
import { setToken, setUser, setSub, expVidPopup, setPasswordPopup, setRegionAccess } from "action/index.js";
import { useNavigate } from "react-router-dom";
import { isWhiteLabel, getSubdomain } from "utils/whiteLabel";

const useLogOut = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = async () => {
    let response = await API({
      method: "POST",
      url: "logout",
    });

    if (response.status && response.status === 200) {
      dispatch(setToken(null));
      dispatch(setUser(null));
      dispatch(setSub(false));
      dispatch(expVidPopup(0));
      dispatch(setPasswordPopup(false));
      dispatch(setRegionAccess(true));
      console.log("VITE_ENV", import.meta.env.VITE_ENV);
      console.log("typeVITE_ENV",typeof import.meta.env.VITE_ENV);
      let LA_URL = import.meta.env.VITE_LA_URL;

      if (isWhiteLabel()) {
        const subdomain = getSubdomain();

        if (subdomain) {
          const url = new URL(LA_URL);
          const hostname = url.hostname;

          // Check if subdomain is already present
          if (!hostname.startsWith(`${subdomain}.`)) {
            url.hostname = `${subdomain}.${hostname}`;
          }

          LA_URL = url.toString();
        }
        window.location.href = `${LA_URL.replace(/\/$/, '')}/auth/login`;
      } else if (import.meta.env.VITE_ENV === "production") {
        console.log("inside production");
        window.location.href = `https://www.languageacademy.com.au/auth/login`;
      }else if(import.meta.env.VITE_ENV === "staging"){
        console.log("inside staging");
        window.location.href = `https://www.la-stagingfe.languageacademy.com.au/auth/login`;
      } else {  
       console.log("inside development");
       window.location.href = "http://www.localhost:3000/auth/login";
      }
     }
   };

  const logoutDirectly = () => {
    dispatch(setToken(null));
    dispatch(setUser(null));
    dispatch(setSub(false));
    dispatch(expVidPopup(0));
    dispatch(setPasswordPopup(false));
    dispatch(setRegionAccess(true));
    // if (import.meta.env.VITE_ENV === "production") {
    //   window.location.href = `https://www.languageacademy.com.au/auth/login`;
    // }else if(import.meta.env.VITE_ENV === "staging"){
    //   window.location.href = `https://www.la-stagingfe.languageacademy.com.au/auth/login`;
    // } else {  
    // window.location.href = "http://www.localhost:3000/auth/login";
    // }
  };

  return { logout, logoutDirectly };
};

export default useLogOut;